import * as React from 'react';

const Sk16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "#F1F2F1", d: "M1.127 5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v1.333h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#0B4EA2", d: "M1.127 6.333h14v3.334h-14z" }), /* @__PURE__ */ React.createElement("path", { fill: "#EE1C25", d: "M1.127 9.667h14V11a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M8.62 5.73 8.6 5.5H4.1l-.02.23S4 6.55 4 8.12c0 1.33.76 2.36 2.24 3.08l.11.05.11-.05c1.48-.72 2.23-1.75 2.24-3.08 0-1.57-.08-2.36-.08-2.39"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#EE1C25",
    d: "M6.28 10.81C5 10.16 4.37 9.28 4.36 8.12c0-1.07.04-1.79.06-2.12v-.13h3.85V6c.03.33.07 1.05.07 2.12 0 1.16-.64 2.05-1.93 2.7l-.06.03-.06-.03z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F1F2F1",
    d: "M6.17 10.26V8.29c-.67 0-.86.06-1.06.12.02-.2.02-.4 0-.61.2.06.39.12 1.06.12v-.55c-.21 0-.5 0-.84.12.02-.2.02-.41 0-.61.33.11.63.12.84.12 0-.16-.05-.5-.11-.78.19.02.39.02.58 0-.06.28-.11.62-.11.78.21 0 .5 0 .84-.12-.02.2-.02.41 0 .61-.33-.11-.63-.12-.84-.12v.55c.67 0 .86-.06 1.06-.12-.02.2-.02.4 0 .61-.2-.06-.39-.12-1.06-.12v1.97z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#0B4EA2",
    d: "m6.24 11.19.11.05.11-.05c.72-.35 1.26-.77 1.63-1.27-.03-.11-.05-.22-.1-.32-.25-.52-.7-.6-1-.18-.04-.09-.08-.18-.13-.25-.36-.52-.87-.41-1.15.25q-.195-.27-.45-.27c-.3 0-.55.32-.66.76.37.5.92.93 1.64 1.27z"
  }
));
Sk16.Size = 16;
Sk16.Title = "Sk";

export { Sk16 as default };
